import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAccVenture } from '../all-ventures-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: DeliveryAreaService): GridSetup<DeliveryAccVenture> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Venture', plural: 'Ventures' },
		getRowKey: row => '' + row.accVentureId,
		stateKey: 'delivery-all-ventures-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Ventures`
		}
	}
}
